import * as _ from 'lodash-es';
import Quill, { Delta } from 'quill/core';

const convertSelectionToCodeEmbed = (
  quill: Quill,
  index: number,
  length: number,
  lastCodeBlockSyntax?: string | null,
) => {
  const [firstLine, firstLineOffset] = quill.getLine(index);
  const [lastLine, lastLineOffset] = length
    ? quill.getLine(index + length)
    : [firstLine, firstLineOffset];

  if (!lastLine) return;

  const fromIndex = index - firstLineOffset;
  const totalLength =
    firstLineOffset + length + lastLine.length() - lastLineOffset;

  const lineText = quill.getText(fromIndex, totalLength);
  const delta = new Delta()
    .retain(fromIndex)
    .delete(totalLength)
    .insert(
      { 'code-embed': new Delta().insert(lineText).ops },
      lastCodeBlockSyntax && lastCodeBlockSyntax !== 'plain'
        ? { language: lastCodeBlockSyntax }
        : undefined,
    );
  quill.updateContents(delta, Quill.sources.USER);
  const [codeEmbed] = quill.getLine(fromIndex);
  _.defer(() => {
    if (codeEmbed?.statics.blotName === 'code-embed') {
      // @ts-expect-error
      codeEmbed.setSelection(firstLineOffset, length, Quill.sources.USER);
    }
  });
};

export default convertSelectionToCodeEmbed;
